module.exports = __webpack_public_path__ + "img/ecosystem_01_eth.0d584f36.png";